import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['topArticles']

  static values = {
    url: String
  }

  connect() {
    if (this.hasUrlValue && this.hasTopArticlesTarget) {
      this.loadTopArticles()
    }
  }

  async loadTopArticles() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) throw new Error('Failed to load')

      const data = await response.json()
      this.renderTopArticles(data.articles || [])
    } catch (error) {
      this.topArticlesTarget.innerHTML = '<p class="text-sm text-red-500">Failed to load top articles</p>'
    }
  }

  renderTopArticles(articles) {
    if (articles.length === 0) {
      this.topArticlesTarget.innerHTML = '<p class="text-sm text-slate-500">No articles with views yet</p>'
      return
    }

    const html = `
      <div class="space-y-3">
        ${articles.map((article, index) => `
          <div class="flex items-center justify-between py-2 ${index > 0 ? 'border-t border-slate-200' : ''}">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-slate-900 truncate">${this.escapeHtml(article.title)}</p>
              <p class="text-xs text-slate-500">${this.escapeHtml(article.category)}</p>
            </div>
            <div class="text-right ml-4">
              <p class="text-sm font-bold text-slate-900">${article.views.toLocaleString()}</p>
              <p class="text-xs text-slate-500">views</p>
            </div>
          </div>
        `).join('')}
      </div>
    `

    this.topArticlesTarget.innerHTML = html
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
